import { IJBPPlanning, SMBFractionTypes } from './IJBPPlanning'

interface IPlanningRowOptions {
  isRollup?: boolean
  excludeAuxiliaryRows?: boolean
  /** Consumers opting in must not add offering totals to their category breakdowns. */
  includeOfferingTotals?: boolean
}

// Works with raw planning rows from both planningGzip and planningCockpitGzip.
export const isCanonicalPlanningRow = (
  row: IJBPPlanning,
  {
    isRollup = false,
    excludeAuxiliaryRows = false,
    includeOfferingTotals = false,
  }: IPlanningRowOptions = {}
): boolean =>
  (includeOfferingTotals || !row.IsTotal) &&
  !row.IsDirect &&
  Boolean(row.IsRollUp) === isRollup &&
  (!row.SMBFraction || row.SMBFraction === SMBFractionTypes.Total) &&
  (!excludeAuxiliaryRows || (!row.IsNoSplit && !row.IsPartnerCount))

export const isPlanningCategoryTotal = (row: IJBPPlanning): boolean =>
  row.SubCategory === 'jbp-overall' && (!row.L3Category || row.L3Category === 'jbp-overall')

export const isPlanningSubCategoryTotal = (row: IJBPPlanning): boolean =>
  Boolean(row.SubCategory) && row.SubCategory !== 'jbp-overall' && row.L3Category === 'jbp-overall'

export const isPlanningPlanRow = (row: IJBPPlanning, fYear: number, fQuarter?: number): boolean =>
  row.FYear === fYear &&
  Boolean(row.IsTarget) &&
  (fQuarter === undefined || row.FQuarter === fQuarter)

export const isPlanningBaselineRow = (
  row: IJBPPlanning,
  fYear: number,
  fQuarter?: number
): boolean =>
  row.FYear === fYear - 1 &&
  Boolean(row.IsActuals) &&
  (fQuarter === undefined || row.FQuarter === fQuarter)
